import Button from "@shared/v2/Button";
import { ArrowPointerSolidV6 } from "@shared/v2/Icomoon";
import Modal from "@shared/v2/Modal";
import Typography from "@shared/v2/Typography";
import { useEffect, useState } from "react";
import { useGoogleAuthUrl } from "../reducers/personalReducer/selectors";

const GmailPermissionModal = () => {
  const [showModal, setShowModal] = useState(false);
  const googleAuthUrl = useGoogleAuthUrl();
  const toggleModal = () => setShowModal((s) => !s);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    if (queryParams.get("error") === "scope") setShowModal(true);
  }, []);

  return (
    <Modal
      containerClassName="!tw-z-3000"
      dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
      contentClassName="tw-max-w-[480px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
      show={showModal}
      onHide={toggleModal}
    >
      {/* @ts-expect-error props */}
      <Modal.Header title="Gmail Permission" closeButton />

      <Modal.Body className="tw-flex tw-flex-col tw-gap-[24px]">
        {/* @ts-expect-error props */}
        <Typography>Whoops, syncing your Gmail account didn’t quite work.</Typography>
        {/* @ts-expect-error props */}
        <Typography>
          Brivity needs you to grant{" "}
          <b>permission to read, compose, send, and delete all your email from Gmail. </b>
          Be sure to check the box when you sync your Gmail.
        </Typography>
        <div className="tw-relative tw-overflow-hidden tw-border-solid tw-border-[1px] tw-border-gray-10 tw-rounded-[8px] tw-shadow-card">
          <img className="tw-w-full" src="/images/gmail-scope.png" alt="Gmail Permission Screenshot" />
          <div className="tw-absolute tw-right-[5.5%] tw-bottom-[39%] tw-w-[10px] tw-h-[10px] tw-bg-semantic-blue-100 tw-bg-opacity-30 tw-animate-ping" />
          <ArrowPointerSolidV6
            className="tw-absolute tw-right-[2.4%] tw-bottom-[24%] tw-text-semantic-blue-100"
            size="xxl"
          />
        </div>
        {/* @ts-expect-error props */}
        <Typography>
          Don’t worry! This will keep your Brivity and Gmail in sync so you are getting all your messages. You
          won’t be able to send email from Brivity until the sync is successful.
        </Typography>
      </Modal.Body>

      <Modal.Footer className="tw-flex tw-justify-between tw-gap-[16px]">
        {/* @ts-expect-error props */}
        <Button schema="tertiary" size="medium" onClick={toggleModal}>
          Don't Sync Gmail
        </Button>
        {/* @ts-expect-error props */}
        <Button size="medium" onClick={() => window.location.assign(googleAuthUrl)}>
          Re-Sync Gmail
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default GmailPermissionModal;
